<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="primary">mdi-database-import</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-btn icon
        absolute
        top
        right
        @click.prevent="dialog = false"
      >
        <v-icon color="blue-grey lighten-2">mdi-close</v-icon>
      </v-btn>
      <v-card-title>
        <span class="headline">Import Positioning Map File</span>
      </v-card-title>
      <v-card-text>
        ポジショニングマップ作成画面の<v-icon color="primary">mdi-download</v-icon>でダウンロードしたファイルを選択してください。一覧に追加されます。
      </v-card-text>
      <v-card-text>
        <v-file-input
          v-model="file"
          label="File input"
          @change="importSheet"
        ></v-file-input>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import common from '@/mixins/common'
import db from '@/mixins/db'

export default {
  mixins: [common, db],
  data () {
    return {
      dialog: false,
      file: null
    }
  },
  methods: {
    // -------- DB利用 --------
    importSheet (file) {
      if (file !== undefined && file !== null) {
        // イベントカテゴリ, イベントアクション, イベントラベル
        this.$ga.event('header', 'change', 'import')

        const reader = new FileReader()
        reader.readAsText(file)
        reader.onload = (e) => {
          const sheet = JSON.parse(reader.result)

          // sheet validation
          if (
            !sheet.objects ||
            !sheet.name ||
            !sheet.time ||
            !sheet.ver ||
            !sheet.top ||
            !sheet.bottom ||
            !sheet.left ||
            !sheet.right ||
            !sheet.copyright
          ) {
            alert('Sorry, file is corrupt.')
            this.file = null
            this.dialog = false
            return false
          }

          // sheet データ調整
          sheet.time = this.getTime()
          delete sheet.no // key の no は削除（念のため）

          this.openDb(() => {
            const store = this.startTransaction('readwrite')
            const req = store.put(sheet)
            req.onsuccess = (e) => {
              this.$emit('set-sheets')
              this.file = null
              this.dialog = false
            }
            req.onerror = (e) => {
              alert('[importSheet openDb Error] Sorry, application error.')
              return false
            }
          })
        }
      }
    }
    // -------- /DB利用 --------
  }
}
</script>
